import React, { useState, useEffect } from 'react'
import "./styles/Policies.css"
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsAndConditions = () => {
    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        setTimeout(() => setFadeIn(true), 1000); // Trigger fade-in after shrink animation
    }, []);

    return (
        <>
            {/* <Header /> */}
            <div className={`policies-page home-page ${fadeIn ? "show" : ""}`}>
                <div className='policies-container fade-in show'>
                    <div className='section section1'>
                        <div className='page-header'>
                            <h2>Terms and Conditions for BunnyKlawz Nail Salon</h2>
                            <p>
                                Please click{" "}
                                <a
                                    href="https://www.instagram.com/bunnyklawz"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    here
                                </a>{" "}
                                to DM @bunnyklawz on Instagram for any questions!
                            </p>
                        </div>

                        <div className='policy-sections'>
                            <h4>Effective Date: April 27<sup>th</sup>, 2025</h4>

                            <h2>Appointments, Deposits, and Cancellations:</h2>
                            <p>A <strong>$10 non-refundable deposit</strong> is required to secure your appointment. This deposit will be applied toward your final service total. If you cancel or do not show up, the deposit remains non-refundable.</p>

                            <h2>Payments:</h2>
                            <p>We accept cash. Full payment is due at the time of service.</p>

                            <h2>Refunds:</h2>
                            <p>Services are non-refundable. If you are unsatisfied, please let us know within 3 days and we will do our best to address any concerns.</p>

                            <h2>Health and Safety:</h2>
                            <p>Please reschedule if you are feeling unwell. We follow strict sanitation procedures to protect clients and staff.</p>

                            <h2>Conduct:</h2>
                            <p>We reserve the right to refuse service to anyone who displays inappropriate behavior or fails to follow salon policies.</p>

                            <h2>Intellectual Property:</h2>
                            <p>All content on this website is owned by BunnyKlawz Nail Salon and may not be copied or used without permission.</p>

                            <h2>Changes to Policies:</h2>
                            <p>We may update these Terms and Privacy Policy at any time. Changes will be posted with the updated effective date.</p>

                            <h2>Contact Us:</h2>
                            <p>If you have any questions, please contact us at [insert contact email].</p>
                        </div>

                    </div>

                    <Footer />
                </div>
            </div>
        </>
    )
}

export default TermsAndConditions
